import type { EntityAction } from './entity-action';

export function isActionVisible<T>(action: EntityAction<T>, entity: T): boolean {
  return action.visible?.(entity) ?? true;
}

export function isActionDisabled<T>(action: EntityAction<T>, entity: T): boolean {
  return action.disabled?.(entity) ?? false;
}

/** Whether the entity has at least one visible, enabled action — to disable the menu trigger otherwise. */
export function hasEnabledActions<T>(actions: EntityAction<T>[], entity: T): boolean {
  return actions.some(
    (action) => !action.separator && isActionVisible(action, entity) && !isActionDisabled(action, entity),
  );
}
